module.exports = __webpack_public_path__ + "static/img/pro5.8cb2e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro5.png
// module id = NxbV
// module chunks = 0